export const SELECT_SUBSCRIPTION_PLAN = 'SELECT_SUBSCRIPTION_PLAN';

export const selectSubscriptionPlan = (planId) => ({
  type: SELECT_SUBSCRIPTION_PLAN,
  payload: {
    planId
  }
});
